import { labels, post } from "./constants";

const addClaim = {
      post: post,
      isSubmitting: false,
      labels: labels.SOMINT
};

export default function reducer(state = addClaim, action) {
      switch (action.type) {
            case "USER":
                  const newLabels = action.payload.center && labels[action.payload.center.system] ? labels[action.payload.center.system] : labels.SOMINT
                  return { ...state, labels: newLabels }
            case "CURRENT_STEP":
                  return { ...state, step: action.payload };
            case "POST":
                  return { ...state, post: action.payload }
            case "CLAIM_IS_SUBMITTING":
                  return { ...state, isSubmitting: action.payload };
            case "PATCH":
                  return {
                        ...state,
                        post: {
                              ...state.post,
                              ...action.payload,
                        },
                  };
            case "PATCH_META":
                  return {
                        ...state,
                        post: {
                              ...state.post,
                              item: {
                                    ...state.post.item,
                                    requested_meta: state.post.item.requested_meta.map(meta =>
                                          meta.name === action.payload.name
                                                ? {
                                                    ...meta,
                                                    scanned: action.payload.scanned,
                                                    is_scanned: Boolean(action.payload.scanned && action.payload.scanned.trim())
                                                  }
                                                : meta
                                    )
                              }
                        }
                  };
            default:
                  return state;
      }
}
